module.exports = __webpack_public_path__ + "static/media/bgMountainMorning.f8c9d95b.jpg";